module.exports = __webpack_public_path__ + "media/2300-1_YR_2022_WebsitesAndLinks.a35fb115.mp4";